function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { css } from "@emotion/react";
import { FormControl, FormHelperText, InputLabel, ListSubheader, MenuItem, Select } from "@mui/material";
// FIXME: Too Many Props.... & Complicate
export default function SelectField(param) {
    var name = param.name, label = param.label, variant = param.variant, size = param.size, inputProps = param.inputProps, options = param.options, disabled = param.disabled, onChange = param.onChange, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_required = param.required, required = _param_required === void 0 ? false : _param_required, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? false : _param_multiple, validate = param.validate, _param_formControlStyle = param.formControlStyle, formControlStyle = _param_formControlStyle === void 0 ? css({}) : _param_formControlStyle;
    var initialValue = React.useMemo(function() {
        return multiple ? [] : undefined;
    }, [
        multiple
    ]);
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        initialValue: initialValue,
        validate: validate,
        children: function(_param) /*#__PURE__*/ {
            var _param_input = _param.input, name = _param_input.name, handleChange = _param_input.onChange, meta = _param.meta, rest = _object_without_properties(_param.input, [
                "name",
                "onChange"
            ]);
            return _jsxs(FormControl, {
                disabled: disabled,
                fullWidth: fullWidth,
                required: required,
                size: size,
                variant: variant,
                error: meta.touched && meta.error,
                css: formControlStyle,
                children: [
                    /*#__PURE__*/ _jsx(InputLabel, {
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        name: name,
                        onChange: function(e) {
                            if (!e.target.value) return;
                            if (Array.isArray(e.target.value) && e.target.value.some(function(value) {
                                return value == null;
                            })) {
                                return; //ListSubheader가 value로 포함되는 이슈
                            }
                            handleChange(e);
                            onChange === null || onChange === void 0 ? void 0 : onChange();
                        },
                        label: label,
                        variant: variant,
                        inputProps: _object_spread({}, inputProps, rest),
                        multiple: multiple,
                        children: options.map(function(option, i) {
                            if (option.type === "groupTitle") {
                                return /*#__PURE__*/ _jsx(ListSubheader, {
                                    disableSticky: true,
                                    children: option.label
                                }, i);
                            } else {
                                return /*#__PURE__*/ _jsx(MenuItem, {
                                    value: option.value,
                                    disabled: option.disabled,
                                    children: option.label
                                }, i);
                            }
                        })
                    }),
                    meta.touched && meta.error && /*#__PURE__*/ _jsx(FormHelperText, {
                        children: meta.error
                    })
                ]
            });
        }
    });
}
